<template>
  <div>support</div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      
    }
  }
};
</script>

<style>
</style>